module.exports = __webpack_public_path__ + "static/media/image_icon.821521bd.svg";